import * as FxFetch from './FxFetch';

export const getCanUpdateDelete = async () => {
  const result = await FxFetch.doJsonX('general/get_invoicing_update_delete', {});
  if (!result || result.boInvoicingUpdateDelete === undefined) {
    return null;
  }
  return Boolean(Number(result.boInvoicingUpdateDelete));
}
